import { Modal } from "@mantine/core";
import React from "react";
import LocalErrorBoundary from "../../../../../util/LocalErrorBoundary";
import IssueModalRoomViewer from "../IssueItemModal/new/IssueModalRoomViewer";

const IssueTableRoomViewerModal: React.FC<{
  opened: boolean;
  onClose: () => void;
}> = ({ opened, onClose }) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Romviewer"
      size="80vw"
      centered
      styles={{
        content: {
          maxWidth: "72rem",
        },
      }}
    >
      <LocalErrorBoundary id="IssueTableRoomViewerModal">
        <IssueModalRoomViewer />
      </LocalErrorBoundary>
    </Modal>
  );
};

export default IssueTableRoomViewerModal;
